<template>
  <el-dialog custom-class="reset-dialog-container" width="400px" v-model="visible" @close="dialogClose" top="30vh" center>
    <template #title>
      <div class="dialog-header">{{t('global.dialog.title.text_1')}}</div>
    </template>
    <div class="dialog-body">
      <svg-icon icon-class="红色叹号" class-name="red-icon"/>
      <p class="dialog-desc">{{errMessage}}</p>
    </div>
    <template #footer>
      <div class="dialog-footer">
        <el-button type="default" @click="dialogClose">{{t('global.dialog.content.text_2')}}</el-button>
        <el-button type="primary" @click="handleReset">{{t('global.dialog.content.text_1')}}</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { ref, watchEffect } from 'vue'
import { useStore } from 'vuex'
import { routeTo } from "@/utils"
import { useI18n } from '@/plugins/i18n'
const { t } = useI18n()

export default {
  name: 'ResetAuthTypeDialog',
  props: {
    viewVisible: {
      type: Boolean,
      default: false
    },
    errMsg: {
      type: String,
      default: t('global.dialog.content.text_3')
    }
  },
  emits: ['close'],
  setup(props, ctx) {
    const store = useStore()
    const visible = ref(false)
    const { t } = useI18n()
    const errMessage = ref(props.errMsg)

    watchEffect(() => {
      visible.value = props.viewVisible
    })

    watchEffect(() => {
      errMessage.value = props.errMsg
    })

    const handleReset = () => {
      store.dispatch('auth/setStep', '0')
      routeTo('/auth/authType')
    }

    const dialogClose = () => {
      ctx.emit('close')
    }

    return {
      visible,
      t,
      handleReset,
      dialogClose,
      errMessage
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
  .reset-dialog-container {
    .dialog-body {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      .dialog-desc {
        width: 90%;
        margin: 0 auto;
      }

      .red-icon {
        font-size: 98px;
      }

      p {
        font-weight: 600;
        text-align: center;
        margin-top: 26px;
      }
    }

    .el-dialog__header {
      margin: 0;
      padding: 0;
      border-radius: 3px;
      overflow: hidden;
    }

    .dialog-header {
      height: 70px;
      padding-left: 35px;
      background-color: #F5FCFE;
      display: flex;
      font-weight: bold;
      align-items: center;
    }

    .dialog-footer {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;
    }
  }
</style>
